export default {"src":"/_next/static/media/card-social.b2b91bdc.svg","height":64,"width":90,"blurWidth":0,"blurHeight":0};